import { derived } from 'svelte/store'
import user from '@/store/user.js'
import { client } from '@/assets/js/pocketbase'

// Thai law: nicotine pouches / snus are 20+ and their image/price display is restricted.
// These categories are hidden (image + price withheld) from anyone who isn't age-verified.
export const RESTRICTED_CATALOGS = new Set(['Snus'])
export const RESTRICTED_MIN_AGE = 20

export function isRestrictedCatalog(catalog) {
    return RESTRICTED_CATALOGS.has(String(catalog || '').trim())
}

// True when the current viewer is allowed to see restricted products:
// staff/admin (browsing their own shop) always, a customer once age-verified, else false.
export const ageOk = derived(user, ($user) => {
    // Must be an actually-authenticated user — the logged-out store default is
    // { id: null, role: 'staff' }, which must NOT bypass the gate.
    if (!$user || !$user.id) return false
    if ($user.role === 'admin' || $user.role === 'staff') return true
    return $user.role === 'customer' && !!$user.ageVerified
})

// Fetch the caller's verification status and mirror it into the user store.
// Safe to call when logged out (returns { status: 'none', ageVerified: false }).
export async function refreshAgeStatus() {
    if (!client.authStore.isValid) return { status: 'none', ageVerified: false }
    try {
        const res = await client.send('/api/jungle/age-status', { method: 'GET' })
        user.commit('ageVerified', !!res?.ageVerified)
        return res || { status: 'none', ageVerified: false }
    } catch {
        return { status: 'none', ageVerified: false }
    }
}
